import React from "react";
import { useQuery } from "react-query";
import { Avatar, Skeleton } from "@mui/material";
import withAuth from "../../Hoc/withAuth";

const sizeMap = {
  small:   { width: 45,  height: 45  },
  medium:  { width: 60,  height: 60  },
  large:   { width: 80,  height: 80  },
  xlarge:  { width: 88,  height: 88  },
};

const AvatarImage = ({ token, uuid, size = "medium" }) => {
  const dims = sizeMap[size] ?? sizeMap.medium;

  const { data, isLoading, isError } = useQuery(
    ["avatar", uuid],
    async () => {
      const res = await fetch(
        `${process.env.REACT_APP_PUBLIC_URL}/images/${uuid}/type/avatar`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (!res.ok) throw new Error("Failed to fetch avatar");
      return res.json();
    },
    {
      enabled:   !!uuid,
      staleTime: 5 * 60 * 1000,
      retry:     1,
    },
  );

  if (isLoading) {
    return <Skeleton variant="circular" width={dims.width} height={dims.height} />;
  }

  if (isError || !data || data?.file_name === "default.jpg") {
    return (
      <Avatar
        alt="Avatar"
        src={`${process.env.REACT_APP_IMAGE_URL}/default.jpg`}
        imgProps={{ crossOrigin: "anonymous" }}
        sx={dims}
      />
    );
  }

  return (
    <Avatar
      alt="Avatar"
      src={`${process.env.REACT_APP_PUBLIC_URL}/images/file/${data.file_name}?w=256`}
      imgProps={{ crossOrigin: "anonymous" }}
      sx={dims}
    />
  );
};

export default withAuth(AvatarImage);
